module.exports = __webpack_public_path__ + "img/banner_2_zh.200176b6.png";